import React from 'react';

import { usePhotoFileInput } from '../hooks/usePhotoFileInput';
import { PhotoUploadIcon } from './PhotoUploadIcon';
import * as S from '../PhotoPicker.styles';

interface Props {
  acceptedFileTypes?: readonly string[];
  addMoreLabel: string;
  emptyBody: string;
  isEmpty: boolean;
  maxFileSizeBytes?: number;
  maxFiles?: number;
  onFilesRejected?: (rejected: { oversized: File[]; wrongType: File[] }) => void;
  onFilesSelected: (files: File[]) => void;
}

export function PhotoPickerDropzone({
  acceptedFileTypes,
  addMoreLabel,
  emptyBody,
  isEmpty,
  maxFileSizeBytes,
  maxFiles,
  onFilesRejected,
  onFilesSelected,
}: Props) {
  const { dropzoneProps, inputProps } = usePhotoFileInput({
    acceptedFileTypes,
    maxFileSizeBytes,
    maxFiles,
    onFilesRejected,
    onFilesSelected,
  });

  return (
    <S.Dropzone {...dropzoneProps} type="button">
      <PhotoUploadIcon />
      <span>{isEmpty ? emptyBody : addMoreLabel}</span>
      <input {...inputProps} data-testid="photopicker-file-input" />
    </S.Dropzone>
  );
}
